import React, { useEffect, useMemo, useState } from "react";
import ApiServices from "../../services/apiServices";
import "./index.css";
import { useLoad } from "../../context/Load";
import Tabela from "../../Components/Tabela";
import { BsFiletypeXlsx } from "react-icons/bs";

export default function RankingPreVenda() {
  const { setLoad } = useLoad();
  const [carregando, setCarregando] = useState(false);
  const [pesquisar, setPesquisar] = useState("");
  const [grupoSelecionado, setGrupoSelecionado] = useState("Todos");
  const [tipoRanking, setTipoRanking] = useState("vendedor");
  const [listaRanking, setListaRanking] = useState([]);
  const [filtroColuna, setFiltroColuna] = useState([]);
  const [paginacao, setPaginacao] = useState({ pageIndex: 0, pageSize: 10 });

  const buscarRanking = async () => {
    setCarregando(true);
    try {
      const visao = tipoRanking === "gerente" ? "gerentes" : "global";
      const response = await ApiServices.apiGet(
        `importacao/campanha-pre-venda/ranking?visao=${visao}`
      );
      setListaRanking(response.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setCarregando(false);
    }
  };

  useEffect(() => {
    buscarRanking();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoRanking]);

  const dadosFiltrados = useMemo(() => {
    return (listaRanking || []).filter((item) => {
      const grupoOk =
        grupoSelecionado === "Todos" ||
        String(item.tierGroup) === String(grupoSelecionado);
      if (!grupoOk) return false;
      if (!pesquisar.trim()) return true;
      const termo = pesquisar.toLowerCase();
      return (
        item.nome?.toLowerCase().includes(termo) ||
        item.dealer?.toLowerCase().includes(termo) ||
        item.chassis?.toLowerCase().includes(termo) ||
        item.cpf?.includes(termo) ||
        item.dealerCode?.includes(termo) ||
        String(item.posicao).includes(termo) ||
        String(item.pontos).includes(termo)
      );
    });
  }, [listaRanking, pesquisar, grupoSelecionado]);

  const dadosFinais = useMemo(() => {
    const inicio = paginacao.pageIndex * paginacao.pageSize;
    return dadosFiltrados.slice(inicio, inicio + paginacao.pageSize);
  }, [dadosFiltrados, paginacao]);

  const colunas = useMemo(() => {
    const base = [
      { accessorKey: "posicao", header: "Posição", size: 80 },
      { accessorKey: "tierGroup", header: "Grupo", size: 70 },
      { accessorKey: "nome", header: "Nome", size: 200 },
      { accessorKey: "cpf", header: "CPF", size: 120 },
      { accessorKey: "dealer", header: "Concessionária", size: 220 },
      { accessorKey: "dealerCode", header: "Dealer Code", size: 100 },
      { accessorKey: "pontos", header: "Qtde", size: 70 },
      {
        accessorKey: "chassis",
        header: "Chassis",
        size: 400,
        Cell: ({ cell }) => (
          <span style={{ fontSize: 12, wordBreak: "break-word" }}>
            {cell.getValue() || "-"}
          </span>
        ),
      },
    ];

    // Na visão de Gerente, ocultar as colunas Nome e CPF.
    if (tipoRanking === "gerente") {
      return base.filter(
        (c) => c.accessorKey !== "nome" && c.accessorKey !== "cpf"
      );
    }
    return base;
  }, [tipoRanking]);

  async function exportar() {
    setLoad(true);
    try {
      const visao = tipoRanking === "gerente" ? "gerentes" : "global";
      await ApiServices.apiDownloadXlsxGET(
        `importacao/campanha-pre-venda/rankingxls?visao=${visao}`,
        tipoRanking === "gerente" ? "ranking-gerentes-pre-venda" : "ranking-vendedores-pre-venda"
      );
    } finally {
      setLoad(false);
    }
  }

  return (
    <div className="row p-3">
      <span className="tituloPagina">RANKING CAMPANHA I20</span>

      <div className="col-md-3 mt-3">
        <label>Ranking</label>
        <select
          className="form-select"
          value={tipoRanking}
          onChange={(e) => setTipoRanking(e.target.value)}
        >
          <option value="vendedor">Vendedor</option>
          <option value="gerente">Gerente</option>
        </select>
      </div>

      <div className="col-md-3 mt-3">
        <label>Grupo (TierGroup)</label>
        <select
          className="form-select"
          value={grupoSelecionado}
          onChange={(e) => setGrupoSelecionado(e.target.value)}
        >
          <option value="Todos">Todos</option>
          <option value="1">Grupo 1</option>
          <option value="2">Grupo 2</option>
          <option value="3">Grupo 3</option>
          <option value="4">Grupo 4</option>
        </select>
      </div>

      <div className="col-md-4 mt-3">
        <label>Pesquisar</label>
        <input
          className="form-control"
          value={pesquisar}
          onChange={(e) => setPesquisar(e.target.value)}
        />
      </div>

      <div className="col-md-2 mt-3 d-flex align-items-end">
        <button className="btn btn-primary w-100" onClick={exportar}>
          <BsFiletypeXlsx /> Exportar
        </button>
      </div>

      <div className="col-12 mt-4">
        <Tabela
          colunas={colunas}
          dados={dadosFinais}
          totalLinhas={dadosFiltrados.length}
          paginacao={paginacao}
          setPaginacao={setPaginacao}
          filtroColuna={filtroColuna}
          setFiltroColuna={setFiltroColuna}
          buscaGlobal={false}
          buscaColunas={false}
          paginacaoPelaApi={true}
        />
      </div>
    </div>
  );
}
